import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import { useBetSlipMsgQuery } from '../Home/Data/SitecoreDataHooks';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { TandCText } from '../BetSlip/LoginMenu';
import '../Home/Login/index.scss';
import { useEffect } from 'react';
import { getDeviceType, useShowAlertDialog} from '../Common/CommonHooks';
import { handleClickMenuItem } from '../Menu/MenuCommon';

const CustomScrollbars = (props) => (
    <Scrollbars
        autoHeight
        autoHeightMin={440}
        autoHeightMax={440}
        autoHide
        autoHideTimeout={1000}
        autoHideDuration={200}
        {...props}
    />
);

// const closeCandTFn = () => {
//     setIsShowTandC(false);
//     if (accessToken) {
//         setShowUserInfo(true);
//         if(window.history.state.idx > 0) {
//             navigate(-1);
//         } else {
//             navigate(`/${i18n.language}/racing`);
//         }

//     }
// };


export const TCModal = (props) => {
    const { onHide,show, isPriorityLoginRef, menu, cwlPage, setCwlPage} = props;
    const { t } = useTranslation();
    const { msgLoading, getBetSlipLoginTnC } = useBetSlipMsgQuery();
    const device = getDeviceType();
    const isMobile = !device.isTablet && !device.isDesktop;
    let mobileStyle = isMobile ? 'is-mobile' : 'is-desktop';
    const { getAlertShowMode } = useShowAlertDialog();
    const hideLPEntry = sessionStorage.getItem('pCardBlacklist') == 'Y' || sessionStorage.getItem('pCardStaff') == 'Y';

    useEffect(() => {
        const href = window.location.href;
        const cwlPageIdx = href.indexOf('cwlPage=');
        if (href.includes('LPEntry=1') && cwlPageIdx !== -1) {
            const gotoCwlPage = href.substring(cwlPageIdx + 'cwlPage='.length);
            setCwlPage(gotoCwlPage);
            window.history.replaceState({},'',window.location.pathname + window.location.hash);
        }
    }, []);
    
    useEffect(() => {
        if (isMobile) {
            mobileStyle = 'is-mobile';
        } else {
            mobileStyle = 'is-desktop';
        }
    }, [isMobile]);
    let textData = '';
    if (!msgLoading) {
        textData = getBetSlipLoginTnC();
        if (textData === '') {
            onHide();
        }
    }
    const handleEnterKey = (event) => {
        if (event.key === "Enter") {
            event.stopPropagation();
            handlePriorityLogin(event);
            onHide();
        }
    };
    const handlePriorityLogin = (e) => {
        if (isPriorityLoginRef && hideLPEntry) {
            getAlertShowMode(t('LS_BS_ERRORPOPUP_PCARD_ONLY_MESSAGE'));
            setTimeout(() => {
                const el = document.querySelector('.PopupAlert-content');
                if (el) {
                    el.style.setProperty('margin-top', 'auto', 'important');
                }
            }, 50);
        }
        if (isPriorityLoginRef && menu != null && !hideLPEntry) {
            let item;
            if (cwlPage) {
                item = {
                    ...menu,
                    itemLink: {
                        ...menu.itemLink,
                        value: cwlPage + '&b_cid=SPLDSP_eWin_LoginOverlay'
                    }
                };
            } else {
                const url = new URL(menu.itemLink.value, window.location.origin);
                url.searchParams.set('b_cid', 'SPLDSP_eWin_LoginOverlay');
                item = {
                    ...menu,
                    itemLink: {
                        ...menu.itemLink,
                        value: url.toString()
                    }
                };
            }
            handleClickMenuItem(e, item, null);
            setCwlPage('');
        }
    };

    useEffect(() => {

        if(show)
            window.addEventListener("keydown", handleEnterKey);
        return () => {
            window.removeEventListener("keydown", handleEnterKey);
        };
    }, [show, isPriorityLoginRef, menu, cwlPage, hideLPEntry]);

    return !msgLoading && textData !== '' ? (
        <Modal
            backdrop="static"
            style={{ zIndex: 100001 }}
            show={show}
            onHide={onHide}
            size="lg"
            dialogClassName={`custom-modal tc-modal ${mobileStyle}`}
            aria-labelledby="tc-modal"
            centered
            backdropClassName="tc-modal-container"
            keyboard = {false}
        >
            <Modal.Header>
                <Modal.Title id="tc-modal">{t('LB_BS_LOGIN_TANDC')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/* <CustomScrollbars> */}
                    <div className="tc-content">
                        <TandCText textData={textData} />
                    </div>
                {/* </CustomScrollbars> */}
                <div className="button-c">
                    <button
                        className="button proceed-button cta_yellow"
                        onClick={(e) => {
                            e.stopPropagation();
                            handlePriorityLogin(e);
                            onHide();
                        }}
                    >
                        {isPriorityLoginRef? t('LB_BS_LOGIN_PRIORITY_TANDCBTN') : t('LB_BS_LOGIN_TANDCBTN')}
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    ) : null;
};